export const USER_TYPE_STORE = 'USER_TYPE_STORE';
export const USER_TYPE_UPDATE = 'USER_TYPE_UPDATE';
export const USER_TYPE_DESTROY = 'USER_TYPE_DESTROY';
